/* ===== AC Gallery: lightbox + cross-gallery select-to-PDF (project pages) =====
   Selections persist across galleries via localStorage (a cart). The PDF spans
   every gallery the viewer selected from, grouped by gallery. */
(function(){
  var gridEl = document.querySelector('.project-grid');
  var titleEl = document.querySelector('.project-title');
  if(!gridEl || !titleEl) return;                  // only on project gallery pages
  var CFG = { project: (titleEl.textContent || '').trim(),
              handle: (location.pathname.split('/').filter(Boolean).pop() || '') };
  var PILOT = []; // [] = every project gallery; add handles to limit to specific ones
  if(PILOT.length && PILOT.indexOf(CFG.handle) === -1) return;

  var JSPDF_URL = "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";
  var FONT_URLS = {
    ebg:   "https://cdn.jsdelivr.net/npm/@expo-google-fonts/eb-garamond/500Medium/EBGaramond_500Medium.ttf",
    ebgIt: "https://cdn.jsdelivr.net/npm/@expo-google-fonts/eb-garamond/400Regular_Italic/EBGaramond_400Regular_Italic.ttf",
    mono:  "https://cdn.jsdelivr.net/npm/@expo-google-fonts/ibm-plex-mono/400Regular/IBMPlexMono_400Regular.ttf"
  };

  // ---- cart (persists across galleries) ----
  var STORE = 'acg_cart_v1';
  function readCart(){ try { return JSON.parse(localStorage.getItem(STORE)) || []; } catch(e){ return []; } }
  function writeCart(c){ try { localStorage.setItem(STORE, JSON.stringify(c)); } catch(e){} }
  function idxOf(cart, src){ for(var i=0;i<cart.length;i++){ if(cart[i].src===src) return i; } return -1; }
  function inCart(src){ return idxOf(readCart(), src) > -1; }

  var slots = Array.prototype.slice.call(document.querySelectorAll('.project-grid .slot'));
  var frames = [];
  slots.forEach(function(slot){
    var img = slot.querySelector('img');
    if(!img) return;
    frames.push({ slot: slot, src: img.getAttribute('src'), alt: img.getAttribute('alt') || '' });
  });
  if(!frames.length) return;

  function pad(n){ return (n<10?'0':'')+n; }

  frames.forEach(function(f, i){
    f.slot.style.cursor = 'zoom-in';
    var b = document.createElement('button');
    b.className = 'acg-sel'; b.type = 'button'; b.setAttribute('aria-label','Select frame');
    b.innerHTML = '<svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"></polyline></svg>';
    b.addEventListener('click', function(e){ e.stopPropagation(); toggle(f); });
    f.slot.appendChild(b);
    f.slot.addEventListener('click', function(){ open(i); });
    if(inCart(f.src)) f.slot.classList.add('acg-on');
  });

  // ---- tray ----
  var tray = document.createElement('div'); tray.className = 'acg-tray';
  tray.innerHTML = '<div class="acg-count"><b>0</b> selected<span>across galleries</span></div>' +
    '<button class="acg-clear" type="button">Clear</button>' +
    '<button class="acg-pdf" type="button" disabled>Download PDF</button>';
  document.body.appendChild(tray);
  var countEl = tray.querySelector('.acg-count b'), pdfBtn = tray.querySelector('.acg-pdf');
  tray.querySelector('.acg-clear').addEventListener('click', function(){
    writeCart([]);
    frames.forEach(function(f){ f.slot.classList.remove('acg-on'); });
    refresh(); if(LB.classList.contains('open')) syncSel();
  });
  pdfBtn.addEventListener('click', onDownload);

  function toggle(f){
    var cart = readCart(); var i = idxOf(cart, f.src);
    if(i > -1) cart.splice(i,1);
    else cart.push({ src: f.src, alt: f.alt, gallery: CFG.project, handle: CFG.handle });
    writeCart(cart);
    f.slot.classList.toggle('acg-on', inCart(f.src));
    refresh(); if(LB.classList.contains('open')) syncSel();
  }
  function refresh(){ var n = readCart().length; countEl.textContent = n; tray.classList.toggle('show', n>0); pdfBtn.disabled = n===0; }

  // ---- lightbox ----
  var LB = document.createElement('div'); LB.className = 'acg-lb'; LB.setAttribute('aria-hidden','true');
  LB.innerHTML = '<div class="acg-counter"></div>' +
    '<button class="acg-close" type="button" aria-label="Close">&times;</button>' +
    '<button class="acg-nav acg-prev" type="button" aria-label="Previous"><span>&#8249;</span></button>' +
    '<img class="acg-lbimg" alt="">' +
    '<button class="acg-nav acg-next" type="button" aria-label="Next"><span>&#8250;</span></button>' +
    '<div class="acg-cap"></div>' +
    '<button class="acg-lbsel" type="button">Select frame</button>';
  document.body.appendChild(LB);
  var lbImg = LB.querySelector('.acg-lbimg'), cur = 0;
  function open(i){ cur=i; render(); LB.classList.add('open'); LB.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; }
  function close(){ LB.classList.remove('open'); LB.setAttribute('aria-hidden','true'); document.body.style.overflow=''; }
  function render(){ var f=frames[cur]; lbImg.src=f.src; lbImg.alt=f.alt;
    LB.querySelector('.acg-counter').textContent = pad(cur+1)+'  /  '+pad(frames.length);
    LB.querySelector('.acg-cap').textContent = f.alt; syncSel(); }
  function syncSel(){ var f=frames[cur], b=LB.querySelector('.acg-lbsel'); var on=inCart(f.src); b.classList.toggle('on', on); b.textContent = on?'Selected':'Select frame'; }
  function step(d){ cur=(cur+d+frames.length)%frames.length; render(); }
  LB.querySelector('.acg-prev').addEventListener('click', function(){ step(-1); });
  LB.querySelector('.acg-next').addEventListener('click', function(){ step(1); });
  LB.querySelector('.acg-close').addEventListener('click', close);
  LB.querySelector('.acg-lbsel').addEventListener('click', function(){ toggle(frames[cur]); });
  LB.addEventListener('click', function(e){ if(e.target===LB) close(); });
  document.addEventListener('keydown', function(e){ if(!LB.classList.contains('open')) return;
    if(e.key==='Escape') close(); else if(e.key==='ArrowLeft') step(-1); else if(e.key==='ArrowRight') step(1); });
  var tx=0, ty=0;
  LB.addEventListener('touchstart', function(e){ tx=e.touches[0].clientX; ty=e.touches[0].clientY; }, {passive:true});
  LB.addEventListener('touchend', function(e){ var dx=e.changedTouches[0].clientX-tx, dy=e.changedTouches[0].clientY-ty; if(Math.abs(dx)>50 && Math.abs(dx)>Math.abs(dy)) step(dx<0?1:-1); }, {passive:true});
  refresh();

  // ---- PDF (libraries + fonts lazy-loaded on first download) ----
  var libs = null;
  function onDownload(){
    if(!readCart().length) return;
    pdfBtn.disabled = true; var lbl = pdfBtn.textContent; pdfBtn.textContent = 'Building...';
    ensureLibs().then(function(){ return buildPdf(readCart()); })
      .then(function(){ pdfBtn.textContent = lbl; pdfBtn.disabled = false; })
      .catch(function(err){ alert('PDF could not be built: ' + err.message); pdfBtn.textContent = lbl; pdfBtn.disabled = false; });
  }
  function loadScript(src){ return new Promise(function(res, rej){ var s=document.createElement('script'); s.src=src; s.onload=res; s.onerror=function(){ rej(new Error('library load failed')); }; document.head.appendChild(s); }); }
  function fetchB64(url){ return fetch(url).then(function(r){ if(!r.ok) throw new Error('asset '+r.status); return r.arrayBuffer(); }).then(function(buf){ var b=new Uint8Array(buf), s=''; for(var i=0;i<b.length;i++) s+=String.fromCharCode(b[i]); return btoa(s); }); }
  function ensureLibs(){
    if(libs) return Promise.resolve(libs);
    return loadScript(JSPDF_URL)
      .then(function(){ return Promise.all([fetchB64(FONT_URLS.ebg), fetchB64(FONT_URLS.ebgIt), fetchB64(FONT_URLS.mono)]); })
      .then(function(f){ libs = { jsPDF: window.jspdf.jsPDF, ebg:f[0], ebgIt:f[1], mono:f[2] }; return libs; });
  }
  function sized(src){ return src + (src.indexOf('?')>-1?'&':'?') + 'width=1600'; }
  function loadImg(url){ return new Promise(function(res, rej){ var im=new Image(); im.crossOrigin='anonymous'; im.onload=function(){ res(im); }; im.onerror=function(){ rej(new Error('image load failed')); }; im.src=url; }); }
  function imgToData(im){ var c=document.createElement('canvas'); c.width=im.naturalWidth; c.height=im.naturalHeight; c.getContext('2d').drawImage(im,0,0); return c.toDataURL('image/jpeg', 0.86); }

  function buildPdf(cart){
    return Promise.all(cart.map(function(it){ return loadImg(sized(it.src)).then(function(im){ return { data: imgToData(im), w: im.naturalWidth, h: im.naturalHeight, gallery: it.gallery || 'Selected Frames' }; }); }))
    .then(function(loaded){
      var groups = [], map = {};
      loaded.forEach(function(it){ if(!(it.gallery in map)){ map[it.gallery] = groups.length; groups.push({ gallery: it.gallery, items: [] }); } groups[map[it.gallery]].items.push(it); });

      var jsPDF = libs.jsPDF, doc = new jsPDF({unit:'pt', format:'letter'});
      doc.addFileToVFS('EBG.ttf', libs.ebg); doc.addFont('EBG.ttf','EBG','normal');
      doc.addFileToVFS('EBGIt.ttf', libs.ebgIt); doc.addFont('EBGIt.ttf','EBGIt','normal');
      doc.addFileToVFS('PM.ttf', libs.mono); doc.addFont('PM.ttf','PM','normal');
      var PW=doc.internal.pageSize.getWidth(), PH=doc.internal.pageSize.getHeight(), ML=54, MR=54, cx=PW/2;
      var cream=[239,232,220], ink=[42,34,28], muted=[106,94,82], hair=[212,204,190];
      function fS(c){ doc.setFillColor(c[0],c[1],c[2]); } function tS(c){ doc.setTextColor(c[0],c[1],c[2]); } function dS(c){ doc.setDrawColor(c[0],c[1],c[2]); }
      function pad2(n){ return (n<10?'0':'')+n; }
      function mono(mx,my,s){ dS(ink); doc.setLineWidth(s*0.075); doc.setLineCap('round'); doc.setLineJoin('round');
        var prev=null, a0=50*Math.PI/180, sw=260*Math.PI/180;
        for(var i=0;i<=72;i++){ var a=a0+sw*i/72, x=mx+s*Math.cos(a), y=my-s*Math.sin(a); if(prev) doc.line(prev[0],prev[1],x,y); prev=[x,y]; }
        var ah=s*0.95, aw=s*0.72, by=my+ah*0.45, ay=my-ah*0.55; doc.line(mx-aw/2,by,mx,ay); doc.line(mx,ay,mx+aw/2,by);
        var c2=my+ah*0.05; doc.line(mx-aw*0.22,c2,mx+aw*0.22,c2); doc.setLineCap('butt'); doc.setLineJoin('miter'); }

      fS(cream); doc.rect(0,0,PW,PH,'F');
      try{ doc.setGState(new doc.GState({opacity:0.045})); fS([42,34,28]); for(var g=0;g<1500;g++){ doc.circle(Math.random()*PW, Math.random()*PH, Math.random()*0.5+0.2, 'F'); } doc.setGState(new doc.GState({opacity:1})); }catch(e){}
      mono(cx, 86, 15);
      doc.setFont('EBG','normal'); doc.setFontSize(16); tS(ink); doc.text('Andrew Cebulka', cx, 122, {align:'center'});
      doc.setFont('PM','normal'); doc.setFontSize(9); tS(muted); doc.text('SELECTED FRAMES', cx, 374, {align:'center', charSpace:3.5});
      doc.setFont('EBG','normal'); doc.setFontSize(54); tS(ink); doc.text('Selections', cx, 422, {align:'center'});
      dS(hair); doc.setLineWidth(0.7); doc.line(cx-32,444,cx+32,444);
      doc.setFont('PM','normal'); doc.setFontSize(8); tS(ink);
      var nF=loaded.length, nG=groups.length;
      var line = nF + (nF===1?' FRAME':' FRAMES') + '   .   ' + nG + (nG===1?' GALLERY':' GALLERIES');
      doc.text(line, cx, 472, {align:'center', charSpace:2.2});
      var today=new Date().toLocaleDateString('en-US',{month:'long',day:'numeric',year:'numeric'});
      doc.setFont('EBGIt','normal'); doc.setFontSize(12); tS(muted); doc.text(today, cx, 492, {align:'center'});
      doc.setFont('PM','normal'); doc.setFontSize(6); tS(muted); doc.text('andrew@andrewcebulka.com   .   843.860.5347   .   andrewcebulka.com   .   Charleston, SC', cx, 752, {align:'center', charSpace:0.6});

      var per=4, cols=2, top=92, bottom=742, cw=PW-ML-MR, cg=26, colW=(cw-cg)/2, rg=34, rb=(bottom-top-rg)/2, ibh=rb;
      groups.forEach(function(grp){
        var pc = Math.ceil(grp.items.length/per);
        grp.items.forEach(function(it, idx){
          var slot = idx % per;
          if(slot===0){
            doc.addPage(); fS(cream); doc.rect(0,0,PW,PH,'F'); var pn=Math.floor(idx/per)+1;
            doc.setFont('PM','normal'); doc.setFontSize(6); tS(muted);
            doc.text((grp.gallery||'SELECTED').toUpperCase()+'   .   SELECTED FRAMES', ML, 56, {charSpace:1.4});
            doc.text('PAGE '+pad2(pn)+' / '+pad2(pc), PW-MR, 56, {align:'right', charSpace:1.4});
            dS(hair); doc.setLineWidth(0.5); doc.line(ML,64,PW-MR,64); doc.line(ML,PH-44,PW-MR,PH-44);
            doc.setFontSize(5.8); doc.text('ANDREW CEBULKA   .   ANDREWCEBULKA.COM   .   REFERENCE ONLY', ML, PH-30, {charSpace:0.6});
          }
          var col=slot%cols, row=Math.floor(slot/cols), cX=ML+col*(colW+cg), cY=top+row*(rb+rg);
          var sc=Math.min(colW/it.w, ibh/it.h), dw=it.w*sc, dh=it.h*sc;
          doc.addImage(it.data,'JPEG', cX+(colW-dw)/2, cY+(ibh-dh)/2, dw, dh);
        });
      });
      doc.save('Andrew-Cebulka-Selects.pdf');
    });
  }
})();
